module.exports = __webpack_public_path__ + "img/double-left-w.2e4c84c5.svg";